import * as React from 'react';
import { Menu } from 'react-admin';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SchoolIcon from '@mui/icons-material/School';
import MusicIcon from '@mui/icons-material/MusicNote';
import authProvider from '../auth/authProvider';

const CustomMenu = () => (
    <Menu
        sx={{
            marginTop: 1,
            '& .RaMenu-item': {
                borderRadius: 1,
            },
        }}
    >
        {authProvider.canSeeVideo() && (
            <Menu.Item to="/courses" primaryText="Courses" leftIcon={<SchoolIcon />} />
        )}
        {authProvider.canSeeAudio() && (
            <Menu.Item to="/audio" primaryText="Audios" leftIcon={<MusicIcon />} />
        )}
    </Menu>
);

export default CustomMenu;
